/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React from "react";
import { GeoPharmacy } from "../../../models/pharmacy/GeoPharmacy";
import { PrescriptionItemFrontend } from "../../../models/ePrescription/local/PrescriptionItemFrontend";
import ProductDetailSection from "../productDetails/ProductDetailSection";
import { PackageType } from "../../../models/ePrescription/VARA/PackageType";
import Modal from "../../../components/Modal/Modal";

interface Props {
  open: boolean;
  close(): void;
  forEdit?: PrescriptionItemFrontend;
  geoPharmacies: GeoPharmacy[];
  updatePrescription(u: PrescriptionItemFrontend): void;
  packageTypes: PackageType[];
}

const UpdateModal: React.FC<Props> = ({ open, close, forEdit, geoPharmacies, updatePrescription, packageTypes }) => {
  return (
    <Modal show={open} handleClose={close} size="modal-lg">
      <Modal.Header closeButton>
        <h3 className="truncate overflow-hidden xl:text-xl font-bold leading-tight text-zinc-800 dark:text-white">      
          {forEdit && forEdit.product && forEdit.product.name ? forEdit.product.name : ""}{" "}
          {forEdit && forEdit.product && forEdit.product.strength ? forEdit.product.strength : ""}{" "}
          {forEdit && forEdit.package && forEdit.package.label ? forEdit.package.label : ""}
        </h3>
      </Modal.Header>
      <Modal.Body>
        <ProductDetailSection
          addPrescription={updatePrescription}
          isVaraLicensed={forEdit?.isVaraLicensed}
          forEdit={forEdit}
          packageTypes={packageTypes}
          productType={forEdit?.product?.productType}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UpdateModal;
